import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import { t } from 'i18next';
import { toast } from 'react-toastify';

import { Title, WellnessHubHeading } from './styles';
import { CardContainer } from '../../components/AdventureCategories/styles';
import { NoComments } from '../../components/SocialFeeds/styles';
import RelatedContent from '../../components/Article/relatedContent';
import FitnessRelatedContent from '../../components/VideoArticle/relatedContent';
import RecipesRelatedContent from '../../components/Recipes/RecipeDetails/relatedContent';
import { fetchApi } from '../../utils/methods';
import { BackArrowFeed, FavouriteIcon, ManagerHistoryIcon } from '../../utils/icons';
import CategorySearchBar from './SearchBar';
import { LikeUnlikeEducationPost } from '../../redux/constants/apiConstants';

const SEARCH_BY_CATEGORY = '/v1/searchByCategory';

const SearchResultsPage = ({ history }) => {
  const location = useLocation();
  const params = new window.URLSearchParams(location.search);

  const categoryName = params.get('category');
  const type = params.get('type');
  const categoryId = Number(params.get('id'));

  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);


  /* Reset when search changes */
  useEffect(() => {
    setResults([]);
    setPage(1);
    setHasMore(true);
  }, [type, categoryId]);

  /* Fetch data on page change */
  // useEffect(() => {
  //   window.console.log("type",type);
  //   window.console.log("categoryId",categoryId);
  //   window.console.log("hasMore",hasMore);
  //   if (type && categoryId && hasMore) {
  //     fetchResults();
  //   }
  //   // eslint-disable-next-line
  // }, [page,categoryId]);

  useEffect(() => {
    if (!type || !categoryId) return;
    if (!hasMore) return;
  
    fetchResults();
    // eslint-disable-next-line
  }, [page, type, categoryId, hasMore]);

  const fetchResults = async () => {
    if (loading || !hasMore) return;
  
    setLoading(true);
    try {
      const payload = {
        type,
        id: categoryId,
        page,
        per_page: 12
      };
  
      const res = await fetchApi(SEARCH_BY_CATEGORY, 'POST', payload);
  
      if (res?.status === 'success') {
        const { results: newResults, current_page, last_page } = res.data;
  
        setResults((prev) =>
          page === 1 ? newResults : [...prev, ...newResults]
        );
  
        setHasMore(current_page < last_page);
      }
    } catch (e) {
      toast.error('Failed to fetch results');
    } finally {
      setLoading(false);
    }
  };
  

  useEffect(() => {
    const handleScroll = () => {
      if (loading || !hasMore) return;
  
      const scrollTop =
        window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
  
      // Trigger 200px before bottom
      if (scrollTop + windowHeight >= docHeight - 200) {
        setPage((prev) => prev + 1);
      }
    };
  
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [loading, hasMore]);
  

  const getSectionTitle = () => {
    if (type === 'article') return `${categoryName} related articles`;
    if (type === 'fitness_video') return `${categoryName} related fitness videos`;
    if (type === 'recipe') return `${categoryName} related recipes`;
    return '';
  };

  const onClickFavoriteRibbon = async (type, typeId, likeStatus, favouriteStatus) => {
    const payload = { type, type_id: typeId, like_status: likeStatus, favorite_status: favouriteStatus };

    try {
      const res = await fetchApi("/" + LikeUnlikeEducationPost, "POST", payload);

      if (res.status === "success") {
        setResults((prev) =>
          prev.map((item) =>
            item.id === typeId ? { ...item, favorite_status: !item.favorite_status } : item
          )
        );
        toast.success(res?.data?.[0]);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("Failed to update favourite");
    }
  };

  const renderCard = (video, index) => {

    if (type === 'article') {
      return (
        <RelatedContent
          key={index}
          video={video}
          history={history}
          margin="0px 0px 20px 0px"
          width="calc((100% / 2) - 12.5px)"
          onClickFavoriteRibbon={onClickFavoriteRibbon}
        />
      );
    }

    if (type === 'fitness_video') {
      return (
        <FitnessRelatedContent
          key={index}
          video={video}
          history={history}
          margin="0px 0px 20px 0px"
          width="calc((100% / 2) - 12.5px)"
          onClickFavoriteRibbon={onClickFavoriteRibbon}
        />
      );
    }

    if (type === 'recipe') {
      return (
        <RecipesRelatedContent
          key={index}
          video={video}
          history={history}
          margin="0px 0px 20px 0px"
          width="calc((100% / 2) - 12.5px)"
          onClickFavoriteRibbon={onClickFavoriteRibbon}
        />
      );
    }

    return null;
  };

  return (
    <div style={{ maxWidth: '1246px', padding: '24px 0 40px', margin: 'auto' }}>
      <WellnessHubHeading>
        <div className="right-row">
          <div className="icon" onClick={() => history.goBack()}>
            {BackArrowFeed('#DA6C74')}
          </div>
          <div className="title">{t(categoryName)}</div>
        </div>
        <div className='left-row'>
          <CategorySearchBar/>
          <div className='icons' onClick={()=>history.push('/wellness-resources/watched-history')}>{ManagerHistoryIcon('#DA6C74',16,16)}</div>
          <div className='icons favourite-icon' onClick={()=>history.push('/wellness-resources/saved-data')}><FavouriteIcon fill={"none"}/></div>
        </div>
      </WellnessHubHeading>

      <Title style={{ margin: '20px 0' }}>{getSectionTitle()}</Title>

      {!results.length && !loading ? (
        <NoComments>{t('No results found')}</NoComments>
      ) : (
        <CardContainer style={{justifyContent:'unset'}}>
          {results.map(renderCard)}
        </CardContainer>
      )}

      {loading && <NoComments>{t('Loading more...')}</NoComments>}
    </div>
  );
};

SearchResultsPage.propTypes = {
  history: PropTypes.object.isRequired
};

export default SearchResultsPage;
